export default __webpack_public_path__ + "static/media/check.0555ccc0.svg";